import { Routes } from '@angular/router';
import { AccountCompletionGuard } from './shared/guards/accountCompletion.guard';
import { AuthEnabledGuard } from './shared/guards/auth-enabled.guard';
import { HomePageRedirectGuard } from './shared/guards/homepage-redirect/homepage-redirect.guard';
import { PathAccessibleGuard } from './shared/guards/pathAccessible.guard';

export const routes: Routes = [
  {
    path: ':lang/pages/:pageUrl',
    loadChildren: () =>
      import('./modules/additional-page-one').then(
        (m) => m.AdditionalPageOneView
      ),
    pathMatch: 'full',
    canActivate: [],
  },
  {
    path: ':lang/terms',
    loadChildren: () => import('./modules/terms').then((m) => m.TermsView),
    pathMatch: 'full',
    canActivate: [PathAccessibleGuard],
  },
  {
    path: ':lang/contact',
    loadChildren: () => import('./modules/contact').then((m) => m.ContactView),
    pathMatch: 'full',
    canActivate: [PathAccessibleGuard],
  },
  {
    path: ':lang/about-us',
    loadChildren: () => import('./modules/about-us').then((m) => m.AboutUsView),
    pathMatch: 'full',
    data: {
      title: 'About Us',
      description: 'This is the about us page',
      image: 'path/to/home-image.jpg',
    },
    canActivate: [PathAccessibleGuard],
  },
  {
    path: ':lang/sell-vehicle',
    loadChildren: () =>
      import('./pages/sell-vehicle').then((m) => m.SellVehicleView),
    data: {
      title: 'Sell a vehicle',
      description: 'This is the sell sa vehicle page',
      image: 'path/to/home-image.jpg',
    },
    canActivate: [PathAccessibleGuard],
  },
  {
    path: ':lang/not-found',
    loadChildren: () =>
      import('./shared/components/not-found').then((m) => m.NotFoundView),
    pathMatch: 'full',
    canActivate: [],
  },
  {
    path: ':lang/auctions-management',
    loadChildren: () =>
      import('./modules/auctions').then((m) => m.AuctionsView),
    pathMatch: 'full',
    canActivate: [PathAccessibleGuard],
  },
  {
    path: ':lang/private-auction',
    loadChildren: () =>
      import('./pages/auctions').then((m) => m.AuctionsViewModule),
    canActivate: [PathAccessibleGuard, AuthEnabledGuard, AccountCompletionGuard],
    data: {
      type: 'private-auction',
    },
  },
  {
    path: ':lang/private-auction/:shortName/machine/:macId',
    loadChildren: () =>
      import('./pages/machine-details').then((m) => m.MachineDetailsView),
    pathMatch: 'full',
    data: {
      type: 'private-auction',
    },
    canActivate: [AuthEnabledGuard, AccountCompletionGuard],
  },
  {
    path: ':lang/private-auction/:shortName/:type/machine/:macId',
    loadChildren: () =>
      import('./pages/machine-details').then((m) => m.MachineDetailsView),
    pathMatch: 'full',
    data: {
      type: 'private-auction',
    },
    canActivate: [AuthEnabledGuard, AccountCompletionGuard],
  },
  {
    path: ':lang/public-auction',
    loadChildren: () =>
      import('./pages/auctions').then((m) => m.AuctionsViewModule),
    canActivate: [PathAccessibleGuard],
    data: {
      type: 'public-auction',
    },
  },
  {
    path: ':lang/public-auction/:shortName/machine/:macId',
    loadChildren: () =>
      import('./pages/machine-details').then((m) => m.MachineDetailsView),
    pathMatch: 'full',
    data: {
      type: 'public-auction',
    },
    canActivate: [AuthEnabledGuard],
  },
  {
    path: ':lang/public-auction/:shortName/:type/machine/:macId',
    loadChildren: () =>
      import('./pages/machine-details').then((m) => m.MachineDetailsView),
    pathMatch: 'full',
    data: {
      type: 'public-auction',
    },
    canActivate: [AuthEnabledGuard],
  },

  {
    path: ':lang/for-sale/machine/:macId',
    loadChildren: () =>
      import('./pages/machine-details').then((m) => m.MachineDetailsView),
    pathMatch: 'full',
    data: {
      title: 'Machine Details Page',
      description: 'This is the machine description page',
      image: 'path/to/home-image.jpg',
    },
    canActivate: [],
  },
  {
    path: ':lang/for-sale',
    pathMatch: 'full',
    loadChildren: () => import('./pages/for-sale').then((m) => m.ForSaleView),
    data: {
      title: 'For Sale',
      description: 'This is the for sale page',
      image: 'path/to/home-image.jpg',
    },
    canActivate: [PathAccessibleGuard],
  },
  {
    path: ':lang/category/:category',
    pathMatch: 'full',
    loadChildren: () => import('./pages/for-sale').then((m) => m.ForSaleView),
    data: {
      title: 'For Sale',
      description: 'This is the for sale page',
      image: 'path/to/home-image.jpg',
    },
    runGuardsAndResolvers: 'always',
    canActivate: [PathAccessibleGuard],
  },
  {
    path: ':lang/category/:category/machine/:macId',
    loadChildren: () =>
      import('./pages/machine-details').then((m) => m.MachineDetailsView),
    pathMatch: 'full',
    data: {
      title: 'Machine Details Page',
      description: 'This is the machine description page',
      image: 'path/to/home-image.jpg',
    },
    canActivate: [],
  },
  {
    path: ':lang/home',
    loadChildren: () =>
      import('./modules/homepage').then((m) => m.HomepageView),
    pathMatch: 'full',
    data: {
      title: 'Home Page',
      description: 'This is the home page',
      image: 'path/to/home-image.jpg',
    },
    canActivate: [PathAccessibleGuard],
  },
  {
    path: ':lang/login',
    loadChildren: () => import('./pages/login').then((m) => m.LoginView),
    pathMatch: 'full',
    data: {
      title: 'Login',
      description: 'User login page.',
    },
    canActivate: [AuthEnabledGuard],
  },
  {
    path: ':lang/forgot-password',
    loadChildren: () => import('./pages/forgot-password').then((m) => m.ForgotPasswordView),
    pathMatch: 'full',
    data: {
      title: 'Forgot password',
      description: 'Password recovery',
    },
    canActivate: [AuthEnabledGuard],
  },
  {
    path: ':lang/register',
    loadChildren: () => import('./pages/register').then((m) => m.RegisterView),
    pathMatch: 'full',
    data: {
      registerType: 'cognito',
      title: 'Signup Page',
      description: 'This is the freemium user signup page',
    },
    canActivate: [AuthEnabledGuard],
  },

  {
    path: ':lang/signup',
    loadChildren: () => import('./pages/register').then((m) => m.RegisterView),
    pathMatch: 'full',
    data: {
      registerType: 'api',
      title: 'Signup Page',
      description: 'This is the freemium user signup page',
    },
    canActivate: [AuthEnabledGuard],
  },
  {
    path: ':lang/validate',
    loadChildren: () =>
      import('./pages/validate').then((m) => m.ValidateEmailView),
    pathMatch: 'full',
    data: {
      title: 'Validate Email',
      description: 'Validate user page.',
    },
    canActivate: [AuthEnabledGuard],
  },
  {
    path: ':lang/private-portals',
    loadChildren: () =>
      import('./pages/private-portals').then((m) => m.PrivatePortalsView),
    pathMatch: 'full',
    data: {
      type: 'private-portals',
      title: 'Private Portals',
      description: 'Private Portals List',
    },
    canActivate: [PathAccessibleGuard, AuthEnabledGuard, AccountCompletionGuard],
  },
  {
    path: ':lang/private-portals/:shortName',
    loadChildren: () =>
      import('./pages/private-portal-for-sale').then((m) => m.PrivatePortalsForSaleView),
    pathMatch: 'full',
    data: {
      type: 'private-portals',
      title: 'Private Portal',
      description: 'Private Portal',
    },
    canActivate: [AuthEnabledGuard, AccountCompletionGuard],
  },
  {
    path: ':lang/private-portals/:shortName/machine/:macId',
    loadChildren: () =>
      import('./pages/machine-details').then((m) => m.MachineDetailsView),
    pathMatch: 'full',
    data: {
      type: 'private-portals',
    },
    canActivate: [AuthEnabledGuard, AccountCompletionGuard],
  },
  {
    path: 'verify-email',
    pathMatch: 'full',
    redirectTo: 'verify-email-code',
  },
  {
    path: 'verify-email-code',
    loadChildren: () => import('./pages/verify-email').then((m) => m.VerifyEmailView),
    pathMatch: 'full',
    data: {
      verifyByCode: true,
    },
    canActivate: [AuthEnabledGuard],
  },
  {
    path: 'verify-phone',
    loadChildren: () => import('./pages/verify-phone').then((m) => m.VerifyPhoneView),
    pathMatch: 'full',
    data: {},
    canActivate: [AuthEnabledGuard],
  },
  {
    path: ':lang',
    pathMatch: 'full',
    loadChildren: () =>
      import('./modules/homepage').then((m) => m.HomepageView),
    canActivate: [PathAccessibleGuard, HomePageRedirectGuard],
  },
  {
    path: '',
    pathMatch: 'full',
    loadChildren: () =>
      import('./modules/homepage').then((m) => m.HomepageView),
    canActivate: [PathAccessibleGuard, HomePageRedirectGuard],
  },
  {
    path: '**',
    pathMatch: 'full',
    loadChildren: () =>
      import('./shared/components/not-found').then((m) => m.NotFoundView),
  },
];
